module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/towards-data-science-2x.e832938a0f7065611f04ec3c1649c6c1.png";